export default "__VITE_ASSET__d1de4ec3__"